import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "rsuite";

import API from "../../utils/api";

import { useConfig } from "../../context/config-context";

import AuthGabarit from "../../components/AuthGabarit";
import { InputConfirmPassword, InputPassword } from "../../components/Inputs";

export default function ResetPasswordPage() {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const siteConfig = useConfig();
  const { id } = useParams();
  const navigate = useNavigate();

  const password = watch("password");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await API.post("/reset-password", { id, ...data });
      navigate(siteConfig.routes.login.path);
    } catch (error) {}
    setLoading(false);
  };

  return (
    <AuthGabarit DisplayLoginButton>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col space-y-2"
      >
        <p className="text-sm">{siteConfig.pages.reset_password.label}</p>
        <InputPassword
          id="password"
          register={register}
          error={errors.password}
        />

        <InputConfirmPassword
          id="confirmPassword"
          hidebutton="true"
          password={password}
          register={register}
          error={errors.confirmPassword}
        />

        <button
          type="submit"
          className="px-10 py-1 mx-auto border rounded w-fit border-primary text-primary hover:bg-primary disabled:bg-transparent hover:text-white"
          disabled={loading}
        >
          {loading ? <Loader /> : siteConfig.pages.reset_password.cta}
        </button>
      </form>
    </AuthGabarit>
  );
}
